import { labelStyle, inputStyle } from '../../../styles';
import { sectionedPanelStyle } from '../CampaignStyles';

export const createPanelStyle = {
    ...sectionedPanelStyle
};

export const listPanelStyle = {
    ...sectionedPanelStyle,
    height: 710,
    marginBottom: 20
};

export const panelContentContainerStyle = {
    display: 'grid',
    gridAutoColumns: 'minmax(max-content, auto)',
    gridTemplateRows: 'max-content auto',
    width: '100%'
};

export const panelTitleContainerStyle = {
    display: 'flex',
    width: '100%',
    padding: '10px 0px 5px 20px'
};

export const panelTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const listContainerStyle = {
    margin: 20
};

export const createContainerCol1Style = {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
};

export const buttonStyle = {
    width: 89,
    height: 35,
    fontSize: 14,
    fontWeight: 'bold'
};

export const datePickerInputStyle = {
    boxSizing: 'border-box',
    height: 40.1,
    outline: 'none',
    padding: '0 2px 0 8px',
    fontSize: 15,
    fontWeight: 600,
    backgroundColor: '#FFFDF4',
    color: '#414141',
    borderRadius: '5px 0 0 5px',
    width: 115
};
export const datePickerButtonStyle = {
    height: 40,
    width: 40
};

export const offAirLabelStyle = {
    ...labelStyle
};

export const offAirInputStyle = {
    ...inputStyle,
    contain: 'none',
    border: '1px solid #D7D7D7'
};

export const radioButton = {
    display: 'flex',
    cursor: 'pointer'
};

export   const radioButtonText = {
    marginLeft: 5.5,
    fontSize: 15
};